import RepositoryService from 'src/services/repository'

const resource = 'trainingSession'

export default RepositoryService.utils.createCrudRepository(resource)
